<template>
  <div class="ma-3">
    <div class="title mb-3">
      Address book <v-icon>mdi-chevron-right</v-icon> Functions management
    </div>

    <div
      layout="column"
      layout-align="center center"
    >
      <div
        layout="column"
        class="field-width"
      >
        <div
          layout="row"
          layout-align="start center"
          class="ml-3"
        >
          <v-text-field
            v-model="filters.keywords"
            solo
            label="Keywords"
            hide-details
            @keyup.enter="fetch"
          />
          <v-btn
            depressed
            color="primary"
            @click="fetch"
          >
            Filter
          </v-btn>
          or
          <a
            href="#"
            class="ml-2 black--text"
            @click="resetFilters"
          >Cancel</a>
        </div>

        <div>
          <v-btn
            flat
            class="mt-3"
            :to="{name: 'admin-addressbook-functions-edit', params: {id: 'new'}}"
          >
            <v-icon
              left
              color="primary"
            >
              mdi-plus-box
            </v-icon>
            Add a new function
          </v-btn>
        </div>

        <v-data-table
          :headers="headers"
          :items="types"
          style="max-width: 1000px"
          :pagination.sync="pagination"
        >
          <template
            slot="items"
            slot-scope="{ item }"
          >
            <td>
              <v-icon
                :color="item.is_enabled ? 'success' : 'error'"
                :title="item.is_enabled ? 'Enabled' : 'Disabled'"
              >
                {{ item.is_enabled ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
              </v-icon>
            </td>
            <td>{{ item.name }}</td>
            <td layout="row">
              <v-btn
                class="mx-0"
                icon
                :to="{name: 'admin-addressbook-functions-edit', params: {id: item.id}}"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                class="mx-0"
                icon
                @click="toggle(item)"
              >
                <v-icon>{{ item.is_enabled ? 'mdi-lock': 'mdi-lock-open' }}</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
    import Params from '@/api/params'

    export default {
        data () {
            return {
                pagination: {
                    rowsPerPage: 10
                },
                headers: [
                    { text: 'Status', value: 'is_enabled', sortable: false, width: 75 },
                    { text: 'Type', value: 'name' },
                    { text: 'Actions', sortable: false, width: "80px" }
                ],
                filters: {
                    keywords: null
                },
                types: []
            }
        },
        mounted () {
            this.fetch();
        },
        methods: {
            fetch () {
                Params.getList('functions', this.filters).then(res => {
                    this.types = res.data;
                })
            },

            resetFilters () {
                this.filters = {keywords: null};
                this.fetch();
            },

            toggle (item) {
                if (item.is_enabled) {
                    Params.disable('functions', item.id).then(() => {
                        this.fetch();
                        this.$snotify.success(`The function "${item.name}" has been disabled`)
                    })
                } else {
                    Params.enable('functions', item.id).then(() => {
                        this.fetch();
                        this.$snotify.success(`The function "${item.name}" has been enabled`)
                    })
                }
            }
        }
    }
</script>
